export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <path d="M11 7.5 L13 5 L16 7 L19 5 L21 7.5" fill="none" stroke="#0B0B0C" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M8.5 27 L12 12.5 Q16 9.5 20 12.5 L23.5 27 Z" fill="#4A0F1F" stroke="#0B0B0C" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M16 11 V27" stroke="#0B0B0C" strokeWidth="1.1" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="font-display text-lg tracking-[0.18em] text-cream sm:text-xl">
      HILMAY’S <span className="italic text-white">KABAS</span>
    </span>
  </span>
);
